import { render, staticRenderFns } from "./TaskArchiveModal.vue?vue&type=template&id=48bef14b&scoped=true"
import script from "./TaskArchiveModal.vue?vue&type=script&lang=js"
export * from "./TaskArchiveModal.vue?vue&type=script&lang=js"
import style0 from "./TaskArchiveModal.vue?vue&type=style&index=0&id=48bef14b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bef14b",
  null
  
)

export default component.exports